import api from './api';

const getAll = (pagination, filter, sortColumn) => api.get('/locality', {
    pageNum: pagination.currentPage - 1,
    pageLength: pagination.itemsPerPage,
    active: filter.active,
    search: filter.search,
    provinceId: filter.provinceId,
    sortBy: sortColumn.sortByColumn,
    orderBy: sortColumn.orderBy
}).then(response => response.data);

const getById = (id) => api.get(`/locality/${id}`).then(response => {
    return response.data
});

const create = (data) => api.post('/locality', data).then(response => {
    return response.data
});

const remove = (id) => api.delete(`/locality/${id}`).then(response => {
    return response.data
});

const update = (id, data) => api.put(`/locality/${id}`, data).then(response => {
    return response.data
});

const getByRegionId = (id) => api.get('/locality/list', {    
    regionId: id
}).then(response => response.data);

const LocalityService = {
    getAll,
    getByRegionId,
    getById,
    create,
    update,
    remove
}

    export default LocalityService;